exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-grid-column-group[data-v-1f4cee90] {\n  display: none;\n}\n", ""]);

// exports
